var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    fill: "#2490C8",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7222 11L13.2222 23.5L14.9722 25.25L25.7222 14.5L36.4722 25.25L38.2222 23.5L25.7222 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5068 41.5547V33.3516H20.3164V32.2236H13.4326V33.3516H16.249V41.5547H17.5068ZM27.5078 36.2158V37.5693C27.5078 39.6201 26.4277 40.6182 25.0127 40.6182C23.5908 40.6182 22.5176 39.6201 22.5176 37.5693V36.2158C22.5176 34.1582 23.5908 33.1602 25.0127 33.1602C26.4277 33.1602 27.5078 34.1582 27.5078 36.2158ZM28.7725 37.5625V36.2158C28.7725 33.5703 27.3027 32.0322 25.0127 32.0322C22.7227 32.0322 21.2529 33.5635 21.2529 36.2158V37.5625C21.2529 40.208 22.7227 41.7461 25.0127 41.7461C27.3027 41.7461 28.7725 40.208 28.7725 37.5625ZM34.4189 32.2236H30.9873V41.5547H32.2451V38.082H34.4121C36.2305 38.082 37.4062 36.8857 37.4062 35.1562C37.4062 33.4336 36.2305 32.2236 34.4189 32.2236ZM36.1143 35.1562C36.1143 36.3047 35.4512 36.9746 34.3027 36.9746H32.2451V33.3379H34.3027C35.4512 33.3379 36.1143 34.001 36.1143 35.1562Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/back_to_top.f4b0675900f5f998d5262c7ccbc42dd4.svg";
export { ForwardRef as ReactComponent };